import { useMediaQuery, useTheme } from '@mui/material';

/** True on phones and narrow tablets (matches Layout drawer breakpoint). */
export function useIsMobile() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
}

/** True on small phones only — use for fullscreen dialogs. */
export function useIsCompact() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
}
